
export const getCourseOutline = (courseOutlineData) => {
  const sections = courseOutlineData.outline.sections
  const subSections = courseOutlineData.outline.sequences

  const sectionsSubSections = sections.map(section => {
    return {
      sectionName: section.title,
      subSections: section.sequence_ids.map(id => subSections[id].title)
    }
  })
  return sectionsSubSections
}